(function () {
  function initForContext(context) {
    var containers = (context || document).querySelectorAll('.testimonials-container-slider .testimonials-swiper');
    if (!containers) return;

    containers.forEach(function (swiperContainer) {
      if (!swiperContainer) return;

      // avoid re-initializing
      if (swiperContainer.classList.contains('swiper-initialized')) return;

      var slides = swiperContainer.querySelectorAll('.swiper-slide');
      var paginationEl = swiperContainer.querySelector('.testimonials-pagination');

      // If there's 0 or 1 slide, do not init slider; hide pagination
      if (!slides || slides.length <= 1) {
        if (paginationEl) paginationEl.style.display = 'none';
        return;
      }

      if (typeof Swiper !== 'undefined') {
        new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          speed: 700,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
          pagination: {
            el: paginationEl,
            clickable: true
          }
        });
      }
    });
  }

  function init() {
    initForContext(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when Shopify sections are loaded in the editor
  document.addEventListener('shopify:section:load', function (event) {
    initForContext(event.target);
  });

})();
